<template>
  <HeadlessTransitionRoot
    v-if="nextNotification"
    appear
    as="template"
    :show="!!nextNotification"
  >
    <HeadlessDialog as="div" class="relative">
      <HeadlessTransitionChild
        as="template"
        enter="duration-500 ease-out"
        enter-from="opacity-0 scale-95"
        enter-to="opacity-100 scale-100"
        leave="duration-100 ease-in"
        leave-from="opacity-100 scale-100"
        leave-to="opacity-0 scale-95"
      >
        <div class="fixed inset-0 bg-black/25" />
      </HeadlessTransitionChild>

      <div
        class="fixed inset-0 flex flex-col items-center justify-start p-4"
      >
        <HeadlessTransitionChild
          as="template"
          enter="duration-100 ease-out"
          enter-from="opacity-0 scale-95"
          enter-to="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leave-from="opacity-100 scale-100"
          leave-to="opacity-0 scale-95"
        >
          <HeadlessDialogPanel
            class="pointer-events-auto flex w-full max-w-lg flex-col items-center justify-center overflow-hidden rounded-lg border border-primary/10 bg-background p-4 shadow-md shadow-primary/20"
          >
            <div
              class="mb-4 flex w-full items-center justify-between"
            >
              <IconBrandLogo class="h-auto w-[12.5rem]" />
              <ButtonWithIcon
                type="button"
                @click="onDismiss(nextNotification)"
              >
                <IconX />
              </ButtonWithIcon>
            </div>

            <NotificationContent
              class="flex-1 overflow-y-auto pr-2"
              :content="nextNotification.contents"
            />
          </HeadlessDialogPanel>
        </HeadlessTransitionChild>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>
</template>

<script setup lang="ts">
import {
  type RetrieveNextNotificationResponse,
  useNextNotification,
} from "@/services/notifications/retrieveNextNotification"
import { viewNotification } from "@/services/notifications/viewNotification"

const lastSeenId = useLocalStorage<string | null>(
  "lastSeenNotification",
  null
)

const { data: nextNotification } = useNextNotification(
  computed(() => ({ lastSeenId: lastSeenId.value }))
)

const onDismiss = async (
  notification: RetrieveNextNotificationResponse
) => {
  lastSeenId.value = notification.id
  await viewNotification(notification.id)
}
</script>
